import React from 'react';

// mui
import { CircularProgress } from '@material-ui/core';

const AutocompleteLoadingIndicator = (props) => {
  return <CircularProgress size={21} />;
};

export default AutocompleteLoadingIndicator;
